var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white relative menucontrol-scroll fixed-top"},[_c('Banner'),_c('VersionTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }